import type { SwitchScopedProps } from '../../switch.types'
import { SwitchLabelVariants } from './switch-label.styles'

import { DISPLAY_NAME, useSwitchContext } from '../../switch'

type SwitchLabelProps = {
  children: React.ReactNode
}

export const SwitchLabel = (props: SwitchLabelProps) => {
  const { children, __scopeSwitch } =
    props as SwitchScopedProps<SwitchLabelProps>

  const { disabled, loading } = useSwitchContext(DISPLAY_NAME, __scopeSwitch)

  const isShowLabel = !loading || disabled
  const isDisabled = disabled

  return (
    <>
      {isShowLabel && (
        <div>
          <label
            className={SwitchLabelVariants({
              isDisabled,
            })}
            data-testid="switch-label"
            aria-label={children?.toString()}
          >
            {children}
          </label>
        </div>
      )}
    </>
  )
}
